<fieldset class="field-set dx-theme-border-color">
    <legend class="legend-title">AAP Workflow Job Details</legend>
    <div class="fieldset-container">
        <dx-box width="100%" height="100%" direction="row">
            <dxi-item [ratio]="0.35">
                <div *dxTemplate>
                    <div class="left-container">
                        <div class="column-container">
                            <div class="label-content">Payee</div>
                            <div class="label-content">
                                <ng-container *ngIf="payeeType === 'VENDOR'">
                                    <app-hyperlink-creator
                                        actionCode="VENDOR_MANAGEMENT"
                                        [displayText]="payee"
                                        [communityId]="communityId"
                                        (onLinkClick)="onVendorClick()"
                                    ></app-hyperlink-creator>
                                </ng-container>
                                <ng-container *ngIf="payeeType !== 'VENDOR'">
                                    {{ payee }}
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-box width="100%" height="100%" direction="row">
                        <dxi-item [ratio]="1" *ngIf="isInternalUser">
                            <div *dxTemplate>
                                <div class="icon-container" (click)="onVendorNotesClick()">
                                    <div class="icon-content">
                                        <ng-container *ngIf="!hasVendorNotes">
                                            <i
                                                title="Vendor Notes"
                                                class="fa-2x dx-theme-accent-as-text-color"
                                                [ngClass]="iconEmptyNotes"
                                            ></i>
                                        </ng-container>
                                        <ng-container *ngIf="hasVendorNotes">
                                            <i
                                                title="Vendor Notes"
                                                class="fa-2x cc-icon-check"
                                                [ngClass]="iconNotes"
                                            ></i>
                                        </ng-container>
                                    </div>
                                    <div class="icon-label-content">Vendor Notes</div>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item *ngIf="!!vendorInstruction && isInternalUser" [ratio]="1">
                            <div *dxTemplate>
                                <div class="icon-container" (click)="onVendorInstructionsClick()">
                                    <div class="icon-content">
                                        <i
                                            title="Vendor Instructions"
                                            class="fa-2x dx-theme-accent-as-text-color"
                                            [ngClass]="iconInstructions"
                                        ></i>
                                    </div>
                                    <div class="icon-label-content">Vendor Instructions</div>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item [ratio]="1" *ngIf="isInternalUser">
                            <div *dxTemplate>
                                <div class="icon-container" (click)="onVendorActivitiesClick()">
                                    <div class="icon-content">
                                        <i
                                            title="Vendor Activities"
                                            class="fa-2x dx-theme-accent-as-text-color"
                                            [ngClass]="iconHistory"
                                        ></i>
                                    </div>
                                    <div class="icon-label-content">Vendor Activities</div>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item *ngIf="hasVendorWFCheckList && isInternalUser" [ratio]="1">
                            <div *dxTemplate>
                                <div class="icon-container" (click)="onVendorChecklistClick()">
                                    <div class="icon-content">
                                        <i
                                            title="Vendor Checklist"
                                            class="fa-2x dx-theme-accent-as-text-color"
                                            [ngClass]="iconChecklist"
                                        ></i>
                                    </div>
                                    <div class="icon-label-content">Vendor Checklist</div>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item [ratio]="1" *ngIf="boardApprovalEnabled">
                            <div *dxTemplate>
                                <div class="icon-container" (click)="onBoardNotesClick()">
                                    <div class="icon-content">
                                        <ng-container *ngIf="!hasBoardNotes">
                                            <i
                                                title="Board Notes"
                                                class="fa-2x dx-theme-accent-as-text-color"
                                                [ngClass]="iconEmptyNotes"
                                            ></i>
                                        </ng-container>
                                        <ng-container *ngIf="hasBoardNotes">
                                            <i
                                                title="Board Notes"
                                                class="fa-2x cc-icon-check"
                                                [ngClass]="iconNotes"
                                            ></i>
                                        </ng-container>
                                    </div>
                                    <div class="icon-label-content">Board Notes</div>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item [ratio]="1" *ngIf="isInternalUser">
                            <div *dxTemplate>
                                <div class="icon-container" (click)="onInternalNotesClick()">
                                    <div class="icon-content">
                                        <ng-container *ngIf="!hasNotes">
                                            <i
                                                title="Notes"
                                                class="fa-2x dx-theme-accent-as-text-color"
                                                [ngClass]="iconEmptyNotes"
                                            ></i>
                                        </ng-container>
                                        <ng-container *ngIf="hasNotes">
                                            <i title="Notes" class="fa-2x cc-icon-check" [ngClass]="iconNotes"></i>
                                        </ng-container>
                                    </div>
                                    <div class="icon-label-content">Internal Notes</div>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item [ratio]="1" *ngIf="isInternalUser">
                            <div *dxTemplate>
                                <div class="icon-container" (click)="onWorkflowHistory()">
                                    <div class="icon-content">
                                        <i
                                            title="Invoice History"
                                            class="fa-2x dx-theme-accent-as-text-color"
                                            [ngClass]="iconHistory"
                                        ></i>
                                    </div>
                                    <div class="icon-label-content">AAP Workflow History</div>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item
                            *ngIf="hasWorkOrders && payeeType === 'VENDOR' && managementCompanyVendorId !== null"
                            [ratio]="1"
                        >
                            <div *dxTemplate>
                                <div class="icon-container" (click)="onWorkOrdersClick()">
                                    <div class="icon-content">
                                        <i
                                            title="Work Orders"
                                            class="fa-2x dx-theme-accent-as-text-color"
                                            [ngClass]="iconHardHat"
                                        ></i>
                                    </div>
                                    <div class="icon-label-content">Work Orders</div>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item *ngIf="hasContracts && isInternalUser" [ratio]="1">
                            <div *dxTemplate>
                                <div class="icon-container" (click)="onContractClick()">
                                    <div class="icon-content">
                                        <i
                                            title="Contracts"
                                            class="fa-2x dx-theme-accent-as-text-color"
                                            [ngClass]="iconFileContract"
                                        ></i>
                                    </div>
                                    <div class="icon-label-content">Contracts</div>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item *ngIf="hasBoardApproval" [ratio]="1">
                            <div *dxTemplate>
                                <div class="icon-container" (click)="onBoardApprovalClick()">
                                    <div *ngIf="!!boardApprovalEnabled" class="icon-content">
                                        <i title="Board Approval" class="fa-2x cc-icon-check" [ngClass]="iconCheck"></i>
                                    </div>
                                    <div *ngIf="!boardApprovalEnabled" class="icon-content">
                                        <i
                                            title="Board Approval"
                                            class="fa-2x cc-text-required"
                                            [ngClass]="iconCross"
                                        ></i>
                                    </div>
                                    <div class="icon-label-content">Board Approval</div>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item [ratio]="1">
                            <div *dxTemplate>
                                <div class="icon-container" (click)="onPdfClick()">
                                    <div class="icon-content">
                                        <i title="Invoice" class="fa-2x" [ngClass]="iconPDF"></i>
                                    </div>
                                    <div class="icon-label-content">Invoice</div>
                                </div>
                            </div>
                        </dxi-item>
                    </dx-box>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</fieldset>

<app-workflow-notes-editor
    *ngIf="showInternalNotes"
    [workflowId]="workflowId"
    [communityId]="communityId"
    [hasNotes]="hasNotes"
    (closeNotesPopUp)="onInternalNotesPopClose($event)"
></app-workflow-notes-editor>

<app-workflow-board-notes-editor
    *ngIf="showBoardNotes"
    [workflowId]="workflowId"
    [communityId]="communityId"
    (closeNotesPopUp)="onBoardNotesClose($event)"
></app-workflow-board-notes-editor>

<app-workflow-vendor-notes
    *ngIf="showVendorNotesPopUp"
    [communityId]="communityId"
    [vendorCode]="payeeCode"
    [vendorName]="payee"
    (onVendorNotesClose)="onVendorNotesClose($event)"
></app-workflow-vendor-notes>

<app-workflow-history
    *ngIf="showHistory"
    [workflowId]="workflowId"
    [communityId]="communityId"
    (onClose)="onHistoryClose()"
></app-workflow-history>

<app-workflow-board-approval-viewer
    *ngIf="showBoardApproval"
    [communityId]="communityId"
    (onClose)="onBoardApprovalClose()"
></app-workflow-board-approval-viewer>

<!-- Instruction Popup -->
<dx-popup
    minWidth="150px"
    minHeight="150px"
    width="50%"
    height="40%"
    title="Coding Instructions"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="showVendorInstructions"
    (onHidden)="onVendorInstructionPopUpClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col" class="instruction-box-container">
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <span>
                        <div class="cc-text-bold">Vendor:&nbsp;</div>
                        {{ payee }}
                    </span>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <div class="cc-text-bold instruction-label">Instructions:</div>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <div class="instruction-container dx-theme-border-color">
                        <dx-scroll-view
                            width="100%"
                            height="100%"
                            direction="vertical"
                            [useNative]="false"
                            [scrollByContent]="true"
                            [scrollByThumb]="true"
                        >
                            {{ vendorInstruction }}
                        </dx-scroll-view>
                    </div>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<cc-message-box #workflowMessageBox></cc-message-box>
